var $5475104f6d631fa8$exports = {};
$5475104f6d631fa8$exports = {
    "longPressMessage": `Naci\u{15B}nij i przytrzymaj lub naci\u{15B}nij klawisze Alt + Strza\u{142}ka w d\xf3\u{142}, aby otworzy\u{107} menu`
};


export {$5475104f6d631fa8$exports as default};
//# sourceMappingURL=pl-PL.mjs.map
